// extracted by mini-css-extract-plugin
module.exports = {"centerStyle":"RemoveDirectFlights-module__centerStyle___j-lz2","searchRemoveIcon":"RemoveDirectFlights-module__searchRemoveIcon___RLFVE"};